import { defineComponent as _defineComponent } from 'vue';
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faCaretDown, faCopy, faDownload, faExternalLinkAlt, faFileExport, faLink, faPlay, faShareAlt, faSpinner, faStar, faTrash, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup, BDropdown, BDropdownItem } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useWorkflowActions } from "./useWorkflowActions";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowActions',
    props: {
        workflow: null,
        published: { type: Boolean, default: false },
        editor: { type: Boolean, default: false },
        current: { type: Boolean, default: false }
    },
    emits: ["refreshList", "dropdown"],
    setup(__props, { emit }) {
        const props = __props;
        const { bookmarkLoading, deleteWorkflow, toggleBookmark, copyPublicLink, copyWorkflow, downloadUrl } = useWorkflowActions(computed(() => props.workflow), () => emit("refreshList", true));
        const userStore = useUserStore();
        const { isAnonymous } = storeToRefs(userStore);
        const shared = computed(() => {
            return !userStore.matchesCurrentUsername(props.workflow.owner);
        });
        const sourceType = computed(() => {
            var _a, _b, _c;
            if ((_a = props.workflow.source_metadata) === null || _a === void 0 ? void 0 : _a.url) {
                return "url";
            }
            else if ((_b = props.workflow.source_metadata) === null || _b === void 0 ? void 0 : _b.trs_server) {
                return `trs_${(_c = props.workflow.source_metadata) === null || _c === void 0 ? void 0 : _c.trs_server}`;
            }
            else {
                return "";
            }
        });
        const runPath = computed(() => `/workflows/run?id=${props.workflow.id}${props.workflow.version !== undefined ? `&version=${props.workflow.version}` : ""}`);
        return { __sfc: true, props, emit, bookmarkLoading, deleteWorkflow, toggleBookmark, copyPublicLink, copyWorkflow, downloadUrl, userStore, isAnonymous, shared, sourceType, runPath, farStar, faCaretDown, faCopy, faDownload, faExternalLinkAlt, faFileExport, faLink, faPlay, faShareAlt, faSpinner, faStar, faTrash, FontAwesomeIcon, BButton, BButtonGroup, BDropdown, BDropdownItem };
    }
});
